import React, { useEffect, useState } from 'react';
import { FilePond, registerPlugin } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import { useToastContext } from '../toast-context';
import { Box } from '@mui/material';

registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateType
);

const XLSX = require('xlsx');

export function UploadCsv({ setPrices, setFailedAssets }) {
  const { showToast } = useToastContext();
  const [files, setFiles] = useState([]);

  useEffect(() => {
    if (files[0]) {
      excelFileToJSON(files[0].file, setPrices, showToast);
    } else {
      setPrices([]);
    }
  }, [files, setPrices, showToast]);

  return (
    <Box
      sx={{
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        borderRadius: '12px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
        border: '1px solid rgba(255, 255, 255, 0.3)',
        backdropFilter: 'blur(8px)',
        p: 2,
        m: 2,
        transition: 'box-shadow 0.3s ease',
        '&:hover': {
          boxShadow: '0 12px 40px rgba(0, 0, 0, 0.15)',
        },
      }}
    >
      <FilePond
        acceptedFileTypes={[
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'application/vnd.ms-excel',
          'text/csv',
        ]}
        files={files}
        onupdatefiles={res => {
          setFailedAssets(null);
          setFiles(res);
        }}
        allowMultiple={false}
        maxFiles={1}
        name="files"
        labelIdle='فایل مد نظر را بکشید یا <span class="filepond--label-action">انتخاب فایل</span>'
        stylePanelLayout={{
          backgroundColor: 'transparent',
        }}
        styleButtonRemoveItem={{
          color: '#f43f5e', // Red from HomePage
        }}
        styleButtonProcessItem={{
          color: '#10b981', // Green from HomePage
        }}
        styleLoadIndicator={{
          color: '#10b981',
        }}
        styleProgressIndicator={{
          color: '#10b981',
        }}
      />
    </Box>
  );
}

function excelFileToJSON(file, setPrices, showToast) {
  try {
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = function (e) {
      const data = e.target.result;
      const workbook = XLSX.read(data, { type: 'binary' });
      const sheetName = workbook.SheetNames[0];
      if (!sheetName) {
        showToast('فایل خالی است یا شیت معتبر ندارد.', 'error');
        setPrices([]);
        return;
      }
      const sheet = workbook.Sheets[sheetName];
      const rows = XLSX.utils.sheet_to_json(sheet, { header: 1 });

      if (rows.length === 0) {
        showToast('هیچ داده‌ای در فایل یافت نشد.', 'error');
        setPrices([]);
        return;
      }

      const headers = rows[0];
      const dataRows = rows.slice(1).map(row => {
        const obj = {};
        headers.forEach((header, index) => {
          const normalizedHeader = header.toString().trim().toLowerCase();
          if (['سریال', 'serial', 'id'].includes(normalizedHeader)) {
            obj['serial'] = row[index];
          } else if (['وزن', 'weight'].includes(normalizedHeader)) {
            obj['weight'] = row[index];
          } else {
            obj[header] = row[index];
          }
        });
        return obj;
      });

      const validRows = dataRows.filter(row => row.serial && row.weight);
      if (validRows.length === 0) {
        showToast('فایل باید شامل ستون‌های "سریال" و "وزن" باشد.', 'error');
        setPrices([]);
        return;
      }

      setPrices(validRows);
      // showToast('فایل با موفقیت بارگذاری شد.', 'success');
    };
    reader.onerror = function () {
      showToast('خطا در خواندن فایل.', 'error');
      setPrices([]);
    };
  } catch (e) {
    showToast('فرمت فایل نامعتبر است یا خطایی رخ داده است.', 'error');
    console.error('Error parsing file:', e);
    setPrices([]);
  }
}
